<template>
    <div>
        <main>
            <div class="post-content">
                <section class="ic-section">
                <div class="container">
                    <div class="ic-div careers-container">
                        <h1 class="accent-heading">Contact Us</h1>
                        <h2 class="page-main-heading">Get In Touch for Care Services</h2>
                    </div>
                    <div class="ic-div contact-wrapper">
                        <div class="ic-div copy-email" @click="sendEmail">
                        <b-icon icon="envelope-fill" scale="1.2"></b-icon>
                        <div class="text" id="email">Email: {{email}}</div>
                        <b-popover target="email" triggers="hover" placement="top">
                            <template #title></template>
                            Copy to clipboard
                        </b-popover>
                        </div>
                        <div class="ic-div copy-telephone-wrapper" @click="call">
                        <div class="ic-div copy-telephone">
                            <b-icon icon="telephone-fill" scale="1.2"></b-icon>
                            <div class="text">Toll Free: {{ phone }}</div>
                        </div>
                        <div class="text-basic">Office hours are 8am - 5pm PST. For off-hours assistance, please leave a message and we will return your call as soon as possible.</div>
                        </div>
                    </div>
                    <div class="form-wrapper row">

                        <div class="form-item col-md-6 col-sm-12">
                        <label for="input-default" class="required ">Your Name:</label>
                        <b-form-input id="input-default"></b-form-input>
                        </div>

                        <div class="form-item col-md-6 col-sm-12" >
                        <label for="input-default" class="required ">Your Email Address:</label>
                        <b-form-input id="input-default"></b-form-input>
                        </div>

                        <div class="form-item col-md-6 col-sm-12">
                        <label for="input-default" class="required ">Your Phone Number</label>
                        <b-form-input id="input-default"></b-form-input>
                        </div>
                    </div>
                    <div class="form-wrapper row">
                        <div class="form-item col-md-12 col-sm-12">
                        <label for="checkbox-group">Preferred Method of Contact:</label>
                        <b-form-checkbox-group
                            id="checkbox-group"
                            v-model="selected"
                            :options="options"
                            :aria-describedby="ariaDescribedby"
                            name="flavour"
                            size="lg"
                        ></b-form-checkbox-group>
                        </div>
                    </div>
                    <div class="form-wrapper row">
                        <div class="form-item col-md-6 col-sm-12">
                        <label for="input-default" class=" ">When do you want care to begin?</label>
                        <b-form-input id="input-default"></b-form-input>
                        </div>

                        <div class="form-item col-md-6 col-sm-12">
                        <label for="input-default" class="required ">Location</label>
                        <b-form-input id="input-default"></b-form-input>
                        </div>
                    </div>
                    <div class="form-wrapper row">
                        <div class="form-item col-md-12 col-sm-12">
                        <label for="input-default" class="required ">Your Message (please include any special requests):</label>
                        <b-form-textarea
                            id="textarea"
                            v-model="text"
                            placeholder=""
                            rows="3"
                        ></b-form-textarea>
                        </div>
                    </div>
                    <div class="btn-submit">Send Your Message</div>
                    <div class="text-basic">
                        <br>
                        Want to join our team?
                        <strong @click="jumpTo('/careers')"><span style="font-weight: 700;">Apply here.</span></strong>
                    </div>
                </div>
                </section>
            </div>
            </main>
    </div>
</template>
<script>
export default {
    name: 'ContactForm',
    data() {
        return {
            selected: [],
            options: [
                { text: 'Phone', value: 'phone' },
                { text: 'Email', value: 'email' }
            ],
            text: '',
            ariaDescribedby: '',
            email: 'contact@ladywseniorcare.ca',
            phone: '(778) 952-8268'
        }
    },
     props: {
        closeModal: Function  // 接收父组件传递的函数
    },
    methods: {
        sendEmail(e) {
            const email = this.email;
            navigator.clipboard.writeText(email).then(function() {
                // console.log("Text successfully copied to clipboard!");
            }).catch(function(err) {
                // console.error("Unable to copy text to clipboard", err);
            });
            const mailtoLink = `mailto:${email}`;
            location.href = mailtoLink;
        },
        call() {
            const phoneNumber = this.phone;
            const telLink = `tel:${phoneNumber}`;
            window.location.href = telLink;
        },
        jumpTo(href) {
            this.closeModal();
            setTimeout(() => {
                this.$router.replace({
                    path: href
                }).catch(()=>{})
            }, 300)
        }
    }
}
</script>
<style lang="scss" scoped>
.post-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  color: $primary-font;
  font-size: 1.8rem;
  line-height: 1.3;
  .ic-section {
    padding: 30px;
  }
  .container {
      display: flex;
      flex-direction: column;
      row-gap: 3rem;
    .contact-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      row-gap: 2.1rem;
      margin-top: 3rem;
    }
    .careers-container {
      row-gap: 0.4rem;
    }
    .accent-heading {
      font-size: 1.4rem;
      font-family: "Montserrat";
      font-style: italic;
      font-weight: 400;
      line-height: 1.2;
    }
    .page-main-heading {
      font-size: 4.4rem;
      color: $primary-font;
      font-family: "Playfair Display";
      font-weight: 800;
      line-height: 1.2
    }
    .text-basic {
      font-size: 1.8rem;
      line-height: 1.3;
      font-weight: 400;
      strong {
        cursor: pointer;
      }
    }
    .copy-email, .copy-telephone {
      flex-direction: row;
      align-items: center;
      column-gap: 4px;
    }
    .copy-telephone-wrapper {
      .text-basic {
        font-size: 1.4rem;
      }
    }
    .text {
      p {
        font-weight: 400;
        margin-block: 1em 0;
      }
    }
    .text > p:first-child {
      margin-block: 0;
    }
    .form-wrapper {
      .form-item {
         margin-bottom: 20px;
      }
      label {
        font-size: 16px;
        font-weight: 600;
        padding-bottom: 5px;
        margin-bottom: 5px;
      }
      label.required {
        &::after {
          content: "*";
          color: red;
          padding-left: .2em
        }
      }
      input {
        height: 40px;
      }
    }
    .btn-submit {
      font-size:18px;
      font-weight:700;
      background-color:$btn-background;
      border-radius: $primary-color;
      padding:16px 40px;
      height: auto;
      display: inline-block;
      width: auto;
      max-width: 100%;
      transition: 0.2s;
      box-shadow: -10px 10px 20px hsl(0,0%,0%,0.1);
      font-weight: 700;
      color: $w-color;
      width: 300px;
      text-align: center;
    }
    .brex-container {
      display: flex;
      flex-direction: column;
      row-gap: 2.2rem;
      h2 {
        font-size: 30px;
        margin-top: 3rem;
      }
      a {
        text-decoration: underline;
        color: $primary-font;
      }
      .ul--no-padding {
        padding-left: 0;
        display: flex;
        flex-direction: column;
        row-gap: 3rem;
      }
      ol {
        padding-inline-start: 40px;
      }
    }
  }
}
 @media (max-width: 767px) {
    .post-content .container .page-main-heading {
      font-size: 2.8rem;
    }
    .post-content .container .contact-wrapper {
      margin-top: 1rem;
    }
 }
</style>


// WEBPACK FOOTER //
// src/components/contactForm.vue